import $ from 'jquery';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

import Section from '../Section';

export default class ProductsBlock extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);
    this.$element = $(element);

    this.grid = element.querySelector('.homepage-featured-products-grid');

    this.applyFadeEffect('.homepage-featured-products-grid', '.homepage-featured-grid-item');

    window.onpageshow = e => {
      if(e.persisted) window.location.reload();
    };

    imagesLoaded(this.grid).on('progress', () => {
      this.masonry.layout();
    });

    document.addEventListener('shopify:section:load', this.initMasonry);
    document.addEventListener('shopify:section:unload', this.destroyMasonry);
    document.addEventListener('shopify:section:select', this.initMasonry);
    document.addEventListener('shopify:section:deselect', this.initMasonry);
    document.addEventListener('shopify:section:reorder', this.initMasonry);

    setTimeout(() => {
      this.initMasonry();
    }, 500);
  }

  destroyMasonry = () => {
    if(this.masonry) {
      this.masonry.destroy();
    }
  }

  initMasonry = () => {
    this.destroyMasonry();

    this.masonry = new Masonry(
      this.grid,
      {
        itemSelector: '.homepage-featured-grid-item',
        // use element for option
        columnWidth: '.homepage-featured-grid-item',
        percentPosition: true,
        gutter: '.gutter-sizer'
      }
    );
  }

  applyFadeEffect = (parent_selector, child_selector) => {
    this.$element.find(parent_selector).each((index, parent) => {
      this.applyFadeEffectToElement(parent, child_selector);
    });
  }

  applyFadeEffectToElement = (el, child_selector) => {
    const children = this.$element.find(el).find(child_selector);

    children.on('mouseenter mouseleave', function(e) {
      children.not(this).stop(true).fadeTo('fast', e.type === 'mouseenter' ? 0.2 : 1);
    });
  }
}
